
      export default {
        functional: true,
        render: 
      function render(_h, _vm) {
        var _c=_vm._c;return _c('svg',{class:[_vm.data.class, _vm.data.staticClass],style:([_vm.data.style, _vm.data.staticStyle]),attrs:{"viewBox":"0 0 32 32","xmlns":"http://www.w3.org/2000/svg"}},[_c('g',{attrs:{"fill":"none","fill-rule":"evenodd"}},[_c('path',{attrs:{"d":"M16 32C7.188 32 0 24.812 0 16 0 7.187 7.188 0 16 0c8.812 0 16 7.188 16 16 0 8.812-7.188 16-16 16z","fill":"#2371D6"}}),_c('path',{attrs:{"d":"M16 5.92c4.136 0 7.5 3.46 7.5 7.714a7.878 7.878 0 01-1.71 4.906 3.566 3.566 0 00-.374.422c-.614.806-1.316 2.171-1.333 2.783 0 2.289-1.831 4.175-4.083 4.175-2.252 0-4.083-1.884-4.083-4.201-.017-.588-.72-1.953-1.335-2.76a2.3 2.3 0 00-.232-.274C9.108 17.16 8.5 15.42 8.5 13.634c0-4.253 3.364-7.714 7.5-7.714zm3.724 11.672c.214-.281.408-.487.54-.603.662-.853 1.083-2.062 1.083-3.355 0-3.033-2.4-5.499-5.347-5.499-2.947 0-5.346 2.466-5.346 5.499 0 1.293.42 2.502 1.216 3.495h.003c.025 0 .2.195.401.46.456.6 1.22 1.812 1.587 2.983h4.281c.369-1.181 1.129-2.386 1.582-2.98zM17.93 21.72c0-.012.006-.026.007-.039H14.07c0 1.134.866 2.025 1.93 2.025s1.93-.891 1.93-1.986z","fill":"#FFF"}})])])
      }
    
      }
    


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/ic_system_remind.svg
// module id = null
// module chunks = 